import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

import Title from "../ui/Title";
import CreateEvent from "../admin/CreateEvent/CreateEvent";
import CreateSport from "../admin/CreateSport/CreateSport";
import CreatePhase from "../admin/CreatePhase/CreatePhase";
import CreateUser from "../admin/CreateUser/CreateUser";
import CreateInstitution from "../admin/CreateInstitution/CreateInstitution";
import CreateSportMaster from "../admin/CreateSportMaster/CreateSportMaster";
import AdminCompanySportsTab from "../admin/AdminCompany/AdminCompanySportsTab.jsx";
import AdminOfficialsTab from "../admin/AdminCompany/AdminOfficialsTab.jsx";
import HayllisCommunicationsPanel from "../admin/HayllisCommunications/HayllisCommunicationsPanel.jsx";
import API_BASE_URL from "../config/config.js";

const AdminSection = () => {
  const [activeTab, setActiveTab] = useState("control-panel");
  const [eventos, setEventos] = useState([]);
  const [deportes, setDeportes] = useState([]);
  const yearSelected = useSelector((state) => state.year.yearSelected);
  const user = useSelector((state) => state.auth.user);
  // Master de Oficiales de partido (FTR-0001): global, rol 1 solamente, no atado a una sola
  // compañía (a diferencia del Master de compañía que sí lo está) — ver runtime finding 1.
  const isOfficialsAdmin = Number(user?.rol) === 1;
  // Comunicados (FTR-0005 Phase 4): mismo criterio rol 1 — gating de UX únicamente, la
  // autorización real vive en requireHayllisNotificationsAdmin del backend.
  const isHayllisCommunicationsAdmin = Number(user?.rol) === 1;

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (yearSelected) {
          const [eventsResponse, sportsResponse] = await Promise.all([
            axios.get(`${API_BASE_URL}/championships?periodo=${yearSelected}`),
            axios.get(`${API_BASE_URL}/sports`),
          ]);

          setEventos(eventsResponse.data);
          setDeportes(sportsResponse.data);
        }
      } catch (error) {
        console.error("Error al traer datos:", error);
      }
    };

    fetchData();
  }, [yearSelected]);

  return (
    <div className="w-full px-4 py-4">
      <div className="mx-auto max-w-6xl">
        <div
          className="mb-5 flex overflow-x-auto rounded-xl border border-slate-200 bg-white p-1 shadow-sm dark:border-slate-600 dark:bg-gray-700"
          role="tablist"
          aria-label="Administración general"
        >
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "control-panel"}
            onClick={() => setActiveTab("control-panel")}
            className={`min-w-[180px] flex-1 rounded-lg px-4 py-2.5 text-sm font-semibold transition-colors ${
              activeTab === "control-panel"
                ? "bg-blue-600 text-white shadow-sm"
                : "text-slate-600 hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-600"
            }`}
          >
            Panel de control
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "company-sports"}
            onClick={() => setActiveTab("company-sports")}
            className={`min-w-[220px] flex-1 rounded-lg px-4 py-2.5 text-sm font-semibold transition-colors ${
              activeTab === "company-sports"
                ? "bg-blue-600 text-white shadow-sm"
                : "text-slate-600 hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-600"
            }`}
          >
            Compañías y deportes
          </button>
          {isOfficialsAdmin && (
            <button
              type="button"
              role="tab"
              aria-selected={activeTab === "officials"}
              onClick={() => setActiveTab("officials")}
              className={`min-w-[180px] flex-1 rounded-lg px-4 py-2.5 text-sm font-semibold transition-colors ${
                activeTab === "officials"
                  ? "bg-blue-600 text-white shadow-sm"
                  : "text-slate-600 hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-600"
              }`}
            >
              Oficiales
            </button>
          )}
          {isHayllisCommunicationsAdmin && (
            <button
              type="button"
              role="tab"
              aria-selected={activeTab === "hayllis-communications"}
              onClick={() => setActiveTab("hayllis-communications")}
              className={`min-w-[180px] flex-1 rounded-lg px-4 py-2.5 text-sm font-semibold transition-colors ${
                activeTab === "hayllis-communications"
                  ? "bg-blue-600 text-white shadow-sm"
                  : "text-slate-600 hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-600"
              }`}
            >
              Comunicados
            </button>
          )}
        </div>

        <div role="tabpanel">
          {activeTab === "control-panel" && (
            <>
              <div className="mb-4">
                <Title>Panel de Control / Admin</Title>
              </div>

              <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-2">
                <div className="space-y-4">
                  <CreateEvent />
                  <CreateSport eventos={eventos} deportes={deportes} />
                  <CreatePhase eventos={eventos} deportes={deportes} />
                </div>

                <div className="space-y-4">
                  <CreateUser />
                  <CreateSportMaster />
                  <CreateInstitution />
                </div>
              </div>
            </>
          )}

          {activeTab === "company-sports" && <AdminCompanySportsTab />}
          {activeTab === "officials" && isOfficialsAdmin && <AdminOfficialsTab />}
          {activeTab === "hayllis-communications" && isHayllisCommunicationsAdmin && (
            <HayllisCommunicationsPanel />
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminSection;
